"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressHintMapperInternal = exports.AddressHintMapper = void 0;
var _constants = require("../constants");
var _TranslationKey = require("../models/TranslationKey");
var _Localization = require("./Localization");
var _jsxRuntime = require("react/jsx-runtime");
class AddressHintMapperInternal {
  getLocalizationKey(label) {
    const transforms = {
      [_constants.NAMES.ZIPCODE]: _TranslationKey.TranslationKey.hintZipCode,
      [_constants.NAMES.CITY]: _TranslationKey.TranslationKey.hintCity,
      [_constants.NAMES.AREA]: _TranslationKey.TranslationKey.hintArea,
      [_constants.NAMES.DELIVERY]: _TranslationKey.TranslationKey.hintDelivery,
      [_constants.NAMES.DISTRICT]: _TranslationKey.TranslationKey.hintDistrict,
      [_constants.NAMES.STREET_ADDRESS]: _TranslationKey.TranslationKey.hintStreetAddress,
      [_constants.NAMES.LOCALITY]: _TranslationKey.TranslationKey.hintLocality,
      [_constants.NAMES.REGION]: _TranslationKey.TranslationKey.hintRegion,
      [_constants.NAMES.PROVINCE]: _TranslationKey.TranslationKey.hintProvince,
      [_constants.NAMES.COUNTRY]: _TranslationKey.TranslationKey.hintCountry,
      [_constants.NAMES.AUTOCOMPLETE]: _TranslationKey.TranslationKey.hintAutocomplete,
      _default: _TranslationKey.TranslationKey.defaultHint
    };
    const key = label in transforms ? transforms[label] : transforms._default;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
      defaultMessage: key,
      id: key
    });
  }
}
exports.AddressHintMapperInternal = AddressHintMapperInternal;
const AddressHintMapper = exports.AddressHintMapper = new AddressHintMapperInternal();
//# sourceMappingURL=AddressHintMapper.js.map